import React, { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { updateFields } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputDropBox from 'apps/auth/components/form/InputDropBox';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_PROFILE_LIMITS, AUTH_PROFILE_SSN } from 'apps/auth/constants/UrlConstants';
import { useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

const ProfileAmlSsnSelect = (props) => {
    const [fieldName, setFieldName] = useState(false);
    const [isDisabledButton, setDisabled] = useState(true);
    const { redirectAfterSuccessValidation = true } = props;
    const { buttonContinue, headerGrayTitle, headerTitle, reviewYourInformationFewMinutes, usuallyTakesCoupleOfSeconds, gotIt } = usePageMessages();
    const fields = useFields(props.formName);
    const { profile_form: profile } = useExtra();

    const getWaiting = () => (
        <InfoPage
            insideModalComponent={true}
            iconName="clock-80"
            iconColor="primary"
            headerText={reviewYourInformationFewMinutes}
            secondaryText={usuallyTakesCoupleOfSeconds}
            primaryButtonLink={AUTH_PROFILE_LIMITS}
            primaryButtonType={'link'}
            primaryButtonCaption={gotIt}
        />
    );

    const getError = (json = {}) => (
        <InfoPage
            insideModalComponent={true}
            animatedIconFail
            headerText={json.messages?.errorTitle}
            secondaryText={json.messages?.errorText}
            topButtonCaption={json.messages?.notNow}
            topButtonType="link"
            topButtonLink={json.extra?.topButtonLink}
            primaryButtonCaption={json.messages?.contactSupport}
            primaryButtonOnClick={() => props.toggleChat(true)}
        />
    );

    const selectHandler = (item) => {
        const newFields = {};
        fields.issue.items.forEach((i) => {
            newFields[i.value] = { ...fields[i.value] };
            newFields[i.value].value = null;
            newFields[i.value].visible = false;
        });
        newFields[item.value].visible = false;
        props.updateFields(props.formName, newFields).then(() => setFieldName(item.value));
    };

    const onChangeHandler = async (value) => {
        const validatedField = await validationAndUpdateValue(null, value, fields[fieldName]);
        const error = validatedField.isError;
        if (!error && isDisabledButton) {
            setDisabled(false);
        } else if (error) {
            setDisabled(true);
        }
    };

    const submitHandler = (_fields, json) => {
        const successText = json?.messages?.successText;
        const errorText = json?.messages?.errorText;
        if (successText) {
            props.redirectAfterSubmit();
        } else if (errorText) {
            const isNewUsaLimits = !UsaService.isNewLimits(profile);
            props.modalRef?.current?.close();
            props.toggleModal(true, <ModalComponent canCloseModal={!isNewUsaLimits}>{isNewUsaLimits ? getWaiting() : getError(json)}</ModalComponent>);
        }
    };

    return (
        <>
            <HeaderPanel title={headerTitle} subtitle={headerGrayTitle} />
            <Form
                id="aml_level_form_id"
                action={AUTH_PROFILE_SSN}
                formName={props.formName}
                checkNotVisibleField={false}
                getCanonicalPath={true}
                onSubmitHandler={submitHandler}
            >
                <Row indent="adaptive-32-48">
                    <InputDropBox formName={props.formName} field={fields.issue} selectHandler={(item) => selectHandler(item)} />
                </Row>
                {fieldName && (
                    <InputText
                        formName={props.formName}
                        field={fields[fieldName]}
                        isClearErrorOnFocus={true}
                        onChangeHandler={(value) => onChangeHandler(value)}
                        isNewInput
                        focus
                    />
                )}
                <input type="hidden" name="redirectAfterSuccessValidation" value={redirectAfterSuccessValidation} />
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="submit"
                        caption={buttonContinue}
                        disabled={isDisabledButton}
                        onClick={(e) => {
                            amplitude.getInstance().logEvent('SSN ITIN Verification Submitted');
                            if (props.onClickContinue) {
                                e.preventDefault();
                                props.onClickContinue(fields);
                            }
                        }}
                    />
                </FixedBottomPanel>
            </Form>
        </>
    );
};

ProfileAmlSsnSelect.propTypes = {
    formName: PropTypes.string.isRequired,
    submitSnnItinHandler: PropTypes.func,
    modalRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { updateFields, toggleModal, toggleChat })(ProfileAmlSsnSelect);
